import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { ASSETS } from "@/lib/site";

export default function Mirror() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const sketchY = useTransform(scrollYProgress, [0, 1], [80, -80]);

  return (
    <section
      ref={ref}
      data-testid="mirror-section"
      className="relative overflow-hidden bg-void py-24 md:py-36"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 md:px-12 lg:grid-cols-12 lg:gap-8">
        {/* Sketch marginalia */}
        <div className="relative lg:col-span-5">
          <motion.div style={{ y: sketchY }} className="relative">
            <img
              data-testid="mirror-sketch"
              src={ASSETS.sketch}
              alt="Ink sketch of a rocket on its launchpad"
              className="w-full max-w-md opacity-90 mix-blend-screen grayscale"
            />
            <div className="pointer-events-none absolute inset-0 bg-rebellion/10 mix-blend-multiply" />
            <p className="mt-4 font-mono text-[0.65rem] uppercase tracking-[0.3em] text-white/35">
              Fig. II — Departure from Earth
            </p>
          </motion.div>
        </div>

        {/* Editorial narrative */}
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mb-6 font-mono text-xs uppercase tracking-[0.3em] text-rebellion">
              Chapter II — The Premise
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mb-8 font-display text-4xl uppercase leading-[0.95] tracking-tight text-paper sm:text-5xl md:text-6xl">
              The Fight for a New Social Contract
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mb-6 font-editorial text-xl leading-relaxed text-white/70 md:text-2xl">
              Following a protagonist&rsquo;s journey to a Martian colony,{" "}
              <em className="text-paper">Election on Mars</em> holds our
              political architecture at arm&rsquo;s length — the promises, the
              erosions, and the small daily fictions we&rsquo;re taught to
              accept without noticing.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-editorial text-xl leading-relaxed text-white/70 md:text-2xl">
              By staging a rigged electoral contest on another planet, the
              novel poses a question we rarely ask on this one: if we were
              writing the social contract today, from scratch, would we still
              sign the one we&rsquo;ve inherited?
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
